// extracted by css-extract-rspack-plugin
export default {"tree":"dz6sIy","left":"jo1yQA","right":"POgZvT"};